import moment from "moment";

export function mapMobileCreateQuoteToModel(
	response: any,
	isTacticaloffer?:boolean,
	targetedPromo?: any,
	retailerName?: string,
	simkitValue?:number,
	promoStackingBehavior?:string,
) {
	const mobileBasePlans = [];
	response?.forEach((element) => {
		mobileBasePlans.push(
			getPlanDetails(element, targetedPromo, retailerName, simkitValue, promoStackingBehavior, isTacticaloffer)
		);
	});
	// mobileBasePlans.sort((a, b) => a.price - b.price);
	return mobileBasePlans;
}

export function getPlanPrice(mobilePlan: any): number {
	if (hasPromoDiscount(mobilePlan)) {
		return (
			parseFloat(mobilePlan?.price) + parseFloat(mobilePlan?.discount?.value)
		);
	} else {
		return parseFloat(mobilePlan?.price);
	}
}


export function getMonthlyText(mobilePlan: any): string {
	if (hasPromoDiscount(mobilePlan)) {
		if (mobilePlan.discount?.upToPeriod && !mobilePlan.discount.isData) {
			return `For the first <strong>${mobilePlan.discount.upToPeriod}
				</strong>month${Number(mobilePlan.discount.upToPeriod) === 1 ? "" : "s"}
				<br>& <strong>$${mobilePlan?.price}/mth</strong> thereafter`;
		} else {
			return "Monthly Cost";
		}
	} else {
		return "Monthly Cost";
	}
}

export function getDiscountText(mobilePlan: any): string {
	if (hasPromoDiscount(mobilePlan) && mobilePlan?.discount?.upToPeriod) {
		return (
			"& <strong>$" +
			parseFloat(mobilePlan.price) +
			"/mth</strong> thereafter"
		);
	} else {
		return "";
	}
}

export function getMobileDiscountDetails(
	mobilePlan: any,
	remainingValue: string,
	targetedPromo?: any,
): any {
	const price = getPlanPrice(mobilePlan) ?? 0;
	const simCredit = parseFloat(remainingValue?.replace("$", ""));
	const dueToday  = (price - simCredit) > 0 ? (price - simCredit) : 0;
	const creditRemaining = simCredit - price;

	console.log("mobile plan")
	console.log(mobilePlan)

	const mobileObj = {
		title: `$${getTitleText(mobilePlan)}-${getTitleTextGB(mobilePlan)}`,
		creditRemaining: creditRemaining > 0 ? creditRemaining : 0, 
		simCredit: simCredit,
		dueToday: dueToday,
		monthlyCost: mobilePlan.price,
		discount: hasPromoDiscount(mobilePlan)
			? mobilePlan?.discount?.value
			: undefined,
		upToPeriod: hasPromoDiscount(mobilePlan)
			? mobilePlan?.discount?.upToPeriod
			: "",
		bonusDataTitle: setCartDataPromoTitle(mobilePlan),
		doubleDataTitle:  mobilePlan?.discount?.isData ? setDoubleDataPromo(mobilePlan) : "",
		doubleDataDescription: mobilePlan?.discount?.isData ? `+${getTitleTextGB(mobilePlan)}`  : "",
		bonusDescription: mobilePlan?.discount?.isData
			? `Then ${getTitleTextGB(mobilePlan)}`
			: "",
		monthlyText: getMonthlyText(mobilePlan),
		targetedPromo: targetedPromo || null,
	};
	return mobileObj;
}

export function hasPromoDiscount(mobilePlan: any): boolean {
	if (mobilePlan?.discount) {
		// const discountValue = mobilePlan.discount.value;
		// Check if termination date is available and it is valid, otherwise allow targeted promo without termination date
		const terminationDate = mobilePlan.discount.terminationDate; // mobilePlan.discount.endDate;
		const isValid = terminationDate
			? moment().isSameOrBefore(terminationDate, "day")
			: true;
		return isValid; // && discountValueTO DO LATER
	} else {
		return false;
	}
}

function getPromoDiscountAmount(tacticalOffers:any[]): number{
	let discount:number = 0;
	if(tacticalOffers?.length >0){
		tacticalOffers.forEach(offerItem => {			
			if(offerItem?.isData === false){
				console.log("offerItem?.offerValue =>", offerItem?.offerValue)
				discount += offerItem?.offerValue;
				console.log("in If Discount =>", discount)
			}		
		});
	}
	console.log("Out If Discount =>", discount)
	return discount;
}

export function isPublicPromoValid(discounts: any): boolean {
	if (
		discounts &&
		discounts.length > 0 &&
		discounts[0].quoteItemPrice &&
		discounts[0].quoteItemPrice.length > 0
	) {
		const terminationDate = discounts[0].terminationDate; 
		if(!terminationDate) { //Termination date can be undefined.
			return true;
		} else {
			const isValid = terminationDate
				? moment().isSameOrBefore(terminationDate, "day")
				: false;
			return isValid;
		}
	} else {
		return false;
	}
}

export function getMobileDiscount(
	mobilePlan: any,
	targetedPromo: any,
	hasTargetedPromo: boolean,
	recurringRPCID: string,
	retailerName: string,
	simKitValue:number,
	promoStackingBehaviour?:string,
	isTacticalOffers:boolean = false
): any {
	const simKitValueStr = `$${simKitValue} Kit`;
	console.log("Simkit Value =>", simKitValueStr);
	const globalPromos = mobilePlan.discounts?.filter(
		(discount) => discount?.discountType?.toLowerCase() === "global"
	);
	console.log("mb plan")
	console.log(mobilePlan)
	console.log("retailerName =>", retailerName);	
 	if (retailerName) {	
		const doubleDataPromos = getBonusorDoubleDataPromo(mobilePlan, 'retail channel bonus data allowance');	
		const retailDistributionRetailerSpecificPromos = mobilePlan?.discounts?.filter(
			(discount) => 
				discount?.discountType?.toLowerCase() === "retail_distribution" && 
				discount?.digitalUIMarketing?.[0]?.productShortDescription === retailerName && 
				discount?.weight !== "99" && 
				discount?.name?.toLowerCase() !== 'retail channel bonus data allowance'
			
		);
		const retailDistributionAllRetailerPromos = mobilePlan?.discounts?.filter(
			(discount) => 
				discount?.discountType?.toLowerCase() === "retail_distribution" && 
				!discount?.digitalUIMarketing?.[0]?.productShortDescription && 
				discount?.weight !== "99" && 
				discount?.name?.toLowerCase() !== 'retail channel bonus data allowance'
		);
		console.log("retailDistributionRetailerSpecificPromos", retailDistributionRetailerSpecificPromos);
		console.log("retailDistributionAllRetailerPromos", retailDistributionAllRetailerPromos);
		let newSimKitPromos = {} ;
		if (simKitValueStr === "$40 Kit"  && doubleDataPromos.length > 0 &&  promoStackingBehaviour && promoStackingBehaviour !== 'Stackable'){
			newSimKitPromos = getApplicableDataPromo(doubleDataPromos, simKitValueStr)
		}else{
			if(['$2 Kit', '$25 Kit', '$30 Kit'].includes(simKitValueStr) && doubleDataPromos.length > 0){
				newSimKitPromos = getApplicableDataPromo(doubleDataPromos, simKitValueStr)
			}			
		}	
		if(newSimKitPromos && Object.keys(newSimKitPromos).length > 0){
			return getGlobalPromo(doubleDataPromos, mobilePlan);
		}else if (retailDistributionRetailerSpecificPromos && retailDistributionRetailerSpecificPromos?.length > 0) {
			retailDistributionRetailerSpecificPromos?.sort((a, b) => a.weight - b.weight);
			return getGlobalPromo(retailDistributionRetailerSpecificPromos, mobilePlan);
		} else if (retailDistributionAllRetailerPromos && retailDistributionAllRetailerPromos?.length > 0) {
			retailDistributionAllRetailerPromos?.sort((a, b) => a.weight - b.weight);
			return getGlobalPromo(retailDistributionAllRetailerPromos, mobilePlan);
		}else if(isTacticalOffers && globalPromos.length >0 && isPublicPromoValid(globalPromos)){
			return getGlobalPromo(globalPromos, mobilePlan, isTacticalOffers)
		}else if(globalPromos &&
			globalPromos.length > 0 &&
			isPublicPromoValid(globalPromos)) {
			return getGlobalPromo(globalPromos, mobilePlan);
		} else {
			return undefined;
		}
	} else {
		let matchedTargetedPromoAction;

		if (hasTargetedPromo) {
			const actions = targetedPromo?.pattern[0]?.action;
			actions.forEach((action) => {
				const actionObjectId = action.actionObjectId;
				if (recurringRPCID === actionObjectId) {
					matchedTargetedPromoAction = action;
				}
			});
		}
		console.log("matchedTargetedPromoAction => ", matchedTargetedPromoAction);
		console.log("globalPromos => ", globalPromos);
		if (matchedTargetedPromoAction) {
			const actionValue = +matchedTargetedPromoAction.actionValue;
			const isPercent = matchedTargetedPromoAction.type === "percent";
			const isFixedAmount = matchedTargetedPromoAction.type === "fixedAmount";
			const isData = matchedTargetedPromoAction.type === "Data";
			const discountValue = isPercent
				? (parseFloat(mobilePlan?.quoteItemPrice[0]?.price?.value) *
						actionValue) /
				100
				: actionValue;
			const discount = {
				isTargetedPromo: true,
				value: isData ? 0 : -Math.abs(discountValue),
				upToPeriod: isData
					? +targetedPromo?.pattern[0]?.action?.filter(
							(action) => action.type === "NoOfMonth"
					)[0]?.actionValue
					: +targetedPromo?.pattern[0]?.action?.filter(
							(action) => action.type === "Billing_Periods"
					)[0]?.actionValue,

				terminationDate: moment(targetedPromo.validFor.endDateTime.split("T")[0]).format(
					"DD MMM YYYY"
				),
				isPercent: isPercent,
				isData: isData,
				data: isData
					? `${matchedTargetedPromoAction?.actionValue}`
					: undefined,
				dataUnit: isData
					? `${matchedTargetedPromoAction?.actionType}`
					: undefined,
				description: "",
				percentage: isPercent ? actionValue : undefined,
				isFixedAmount: isFixedAmount,
				fixedAmount: isFixedAmount ? actionValue : 0,
				title: "",
				promotionName: getTargetedPromotionName(targetedPromo)
			};
			discount.title = setPromotitle(mobilePlan, discount);
			discount.description = setPromoDescription(discount);
			return discount;
		}else if(isTacticalOffers && globalPromos.length >0 && isPublicPromoValid(globalPromos)){
			return getGlobalPromo(globalPromos, mobilePlan, isTacticalOffers)
		} else if(
			globalPromos &&
			globalPromos.length > 0 &&
			isPublicPromoValid(globalPromos)
		) {
			return getGlobalPromo(globalPromos, mobilePlan);
		} else {
			return undefined;
		}
	}
}

function getGlobalPromo(globalPromos: any, mobilePlan: any, isTacticalOffer:boolean = false): any {
	console.log("Global Promos Mobile Plan =>", mobilePlan);
	console.log("Global Promos =>", globalPromos);
	console.log("Global isTacticalOffer =>", isTacticalOffer);
	if(isTacticalOffer){
		const tacticalOffers:any = [];
			globalPromos.forEach(promoItem => {			
				console.log("promo Item =>", promoItem)
				if(promoItem.weight === '10' && isPromoValid(promoItem)){
					const discount = getDiscountValues(promoItem);
					discount.title = setPromotitle(mobilePlan, discount);
					discount.dataPromoTitle = dataPromoTitle(mobilePlan, discount);
					discount.description = setPromoDescription(discount);			
					tacticalOffers.push(discount);					
				}
			});
		return tacticalOffers;
	}else{	
	
	const discount = getDiscountValues(globalPromos[0]);
		discount.title = setPromotitle(mobilePlan, discount);
		discount.dataPromoTitle = dataPromoTitle(mobilePlan, discount);
		discount.description = setPromoDescription(discount);
		return discount;
	}
}

function getTargetedPromotionName(targetedPromo : any) : string {
	let promoName : string;
	promoName = targetedPromo?.originalResult && JSON.parse(targetedPromo?.originalResult)?.data?.promotionCode?.customFields?.PromoName?.value;
	return promoName;
}

function setDoubleDataPromo(mobilePlan: any): string {
	if (mobilePlan?.discount?.isData) {
		const text = mobilePlan?.discount?.promotionName?.split(" ");
		if(text?.[0] === "Double")
		return "Double Data"
	} else {
		return "";
	}
}

function setCartDataPromoTitle(mobilePlan: any): string {
	if (mobilePlan?.discount?.isData) {
		const titleText = getTitleTextGB(mobilePlan);
		const extractNumber = +titleText.match(/\d+/g)[0];
		const discountedData = extractNumber + Number(mobilePlan.discount.data);
		if (mobilePlan.discount.upToPeriod === 1) {
			return `<strong>${discountedData}${mobilePlan.discount.dataUnit}</strong> data on Activation`;
		} else {
			return `<strong>${discountedData}${mobilePlan.discount.dataUnit}</strong> data for first ${mobilePlan.discount.upToPeriod} months`;
		}
	} else {
		return "";
	}
}

export function setCartTacticalOffersDisounts(tacticalOffers?:any){
	const discountoffers:any = [];
	if (!Array.isArray(tacticalOffers)) {
		return discountoffers;
	}
	tacticalOffers.forEach(offerItem => {
		console.log("offer Item in Set Cart=>",offerItem)
		 const cartPromoTitle = (offerItem.cartDiscountLabel)? offerItem.cartDiscountLabel : "";
		 const discount = {
			    promoName: offerItem?.promotionName,
				isData:offerItem.isData,
				cartRibbonLabel:cartPromoTitle,
				cartTitle: (offerItem.isData) ? cartPromoTitle?.toLowerCase()?.includes('double data')? "Double data": "Bonus data"	: 'Discount',
				cssClass: (offerItem.isData) ? 'data-discount': 'amount-discount',
				discountType:(offerItem.isData)?'data':'amount',
				isPercent:offerItem?.isPercent,
				isFixed:offerItem?.isFixed,
				fixedAmount:offerItem?.fixedAmount,
				percentage:offerItem?.percentage,
				offerDataValue:offerItem.dataPromoTitle,
				offerEnds:offerItem.terminationDate,
				offerValidFor:offerItem.upToPeriod,
				offerValue:offerItem.value
			};		
 			discountoffers.push(discount);	
	});
	return discountoffers;
}

export function setPromotitle(mobilePlan: any, discount: any): string {
	const titleText = getTitleTextGB(mobilePlan);
	if (discount.isData) {
		const extractNumber = +titleText.match(/\d+/g)[0];
		const discountedData = extractNumber + Number(discount.data);
		if (discount.upToPeriod === 1 || isNaN(discount.upToPeriod)) {
			return `<span class="text-style-2">${titleText}</span> + bonus <span class="text-style-2">${discount.data}${discount.dataUnit}</span>`;
		} else {
			return `<span class="text-style-2">${discountedData}${discount.dataUnit}</span>`;
		}
	} else if (discount.isFixedAmount || discount.isPercent) {
			return `<span class="text-style-2">${titleText}</span>`;
	} else {
		return "";
	}
}

export function dataPromoTitle(mobilePlan: any, discount: any): string {
	const titleText = getTitleTextGB(mobilePlan);
	if (discount.isData) {
		const extractNumber = +titleText.match(/\d+/g)[0];
		const discountedData = extractNumber + Number(discount.data);
		if (discount.upToPeriod === 1 || isNaN(discount.upToPeriod)) {
			return `${titleText} + bonus ${discount.data}${discount.dataUnit}`;
		} else {
			return `${discountedData}${discount.dataUnit}`;
		}
	}
}

function setPromoDescription(discount: any): string {
	if (discount.isData) {
		return discount.upToPeriod == 1
			? `Bonus ${discount.data}${discount.dataUnit} on Activation` // discount?.promotionName
			: undefined;
		// discount.upToPeriod > 1
		// ? `${
		// 		+discount.data +
		// 		Number(getTitleTextGB(mobilePlan).match(/\d+/g)[0])
		//   }${discount?.dataUnit}`
	} else {
		return "";
	}
}

function getBonusorDoubleDataPromo(mobilePlan: any, discountName:string){
	const dataPromos = mobilePlan?.discounts?.filter(
			(discount) => {
				console.log("discount data retail=> ",discount);
				return discount?.discountType?.toLowerCase() === "retail_distribution" &&  (discount?.name?.toLowerCase() === discountName )
			}
		);
	return dataPromos;
}

function getApplicableDataPromo(dataPromos:any, simKitValueStr:string){
	const configuredAllowedSimkits = dataPromos[0].characterstic?.find( charactersticItem => {				
				return charactersticItem?.characteristicDescription === 'allowedSIMKit' 
				&& charactersticItem?.characteristicCharValue.find(charValue => {
					return charValue?.value === simKitValueStr;
				})
			})
	return configuredAllowedSimkits;
}

function getDiscountValues(mobilePromo:any){
	const discount = {
		isGlobalPromo: mobilePromo?.discountType?.toLowerCase() === "global" ? true : false,
		isRetailDistributionPromo: mobilePromo?.discountType?.toLowerCase() === "retail_distribution" ? true : false,
		selected: true,
		id: mobilePromo?.elementGuid,
		name: mobilePromo?.name,
		weight:mobilePromo?.weight,
		retailerName: undefined,
		value: parseFloat(mobilePromo?.quoteItemPrice[0]?.price?.value),
		upToPeriod:
			+mobilePromo?.quoteItemPrice[0]?.price?.attributes?.filter(
				(attribute) => attribute.name === "upToPeriods"
			)[0]?.value,
		terminationDate: mobilePromo?.terminationDate // globalPromos[0].quoteItemPrice[0].price?.endDate
			? moment(mobilePromo?.terminationDate).subtract(1, "days").format("DD MMM YYYY") // Subtract one day as per OPMO-2532
			: undefined,
		isPercent:
			mobilePromo?.quoteItemPrice[0]?.price?.attributes?.filter(
				(attribute) => attribute.name === "Discount_Type"
			)[0]?.value === "percent",
		percentage:
			mobilePromo?.quoteItemPrice[0]?.price?.attributes?.filter(
				(attribute) => attribute.name === "percentage"
			)[0]?.value,
		isData:
			mobilePromo?.quoteItemPrice[0]?.price?.attributes?.filter(
					(attribute) => attribute.name === "Discount_Type"
				)[0]?.value.toLowerCase() === "data",
		data: `${
			mobilePromo?.quoteItemPrice[0]?.price?.attributes?.filter(
				(attribute) => attribute.name === "Data_Allowance"
			)[0]?.value
		}`,
		dataUnit: `${
			mobilePromo?.quoteItemPrice[0]?.price?.attributes?.filter(
				(attribute) => attribute.name === "Unit_Of_Measure"
			)[0]?.value
		}`,
		isFixedAmount:
			mobilePromo?.quoteItemPrice[0]?.price?.attributes?.filter(
				(attribute) => attribute.name === "Discount_Type"
			)[0]?.value === "fixedAmount",
		fixedAmount: +mobilePromo?.quoteItemPrice[0]?.price?.value,
		promotionName:
			mobilePromo?.quoteItemPrice[0]?.price?.attributes?.filter(
				(attribute) => attribute.name === "promotionName"
			)[0]?.value,
		description: '',
		title: "",
		cartDiscountLabel:mobilePromo?.quoteItemPrice[0]?.price?.attributes?.filter(
				(attribute) => attribute.name === "cpqCartLabel"
			)[0]?.value ?? '',
		grandParentElementGuid: mobilePromo?.grandParentElementGuid,
		parentElementGuid: mobilePromo?.parentElementGuid,
		elementGuid: mobilePromo?.elementGuid,
		dataPromoTitle: ''
	};
 return discount;
}
function isPromoValid(discount){
	const terminationDate = discount.terminationDate; 
		if(!terminationDate) { //Termination date can be undefined.
			return true;
		} else {
			const isValid = terminationDate
				? moment().isSameOrBefore(terminationDate, "day")
				: false;
			return isValid;
		}
}
	


export function getThirdPartyDiscounts(mobilePlan: any): any {
	const thirdPartyPromoGroup = mobilePlan.discounts.filter(
		(discount) =>
			discount?.discountType?.toLowerCase() === "third_party_promo_group"
	);
	if (thirdPartyPromoGroup && thirdPartyPromoGroup.length > 0) {
		// TODO: Check third party promo is valid
		//  isPublicPromoValid(nbnSpeedModel)) {
		const discounts = [];
		thirdPartyPromoGroup.forEach((thirdPartyDiscount) => {
			const discount = {
				isPublicPromo: false,
				selected: false,
				id: thirdPartyDiscount.elementGuid,
				name: thirdPartyDiscount.name,
				value: thirdPartyDiscount.quoteItemPrice[0].price.value,
				upToPeriod:
					thirdPartyDiscount.quoteItemPrice[0].price.attributes.filter(
						(attribute) =>
							attribute.name?.toLowerCase() === "uptoperiods"
					)[0]?.value,
				terminationDate: thirdPartyDiscount.terminationDate,
				isPercent:
					thirdPartyDiscount.quoteItemPrice[0].price.attributes
						.filter(
							(attribute) =>
								attribute.name?.toLowerCase() ===
								"discount_type"
						)[0]
						.value?.toLowerCase() === "percent",
				percentage:
					thirdPartyDiscount.quoteItemPrice[0].price.attributes.filter(
						(attribute) =>
							attribute.name?.toLowerCase() === "percentage"
					)[0]?.value,
				description: undefined,
			};

			if (thirdPartyDiscount.terminationDate) {
				const endDate = moment(thirdPartyDiscount.terminationDate);
				discount.terminationDate = endDate.subtract(1, "days");
			}
			discounts.push(discount);
		});
		return discounts;
	} else {
		return undefined;
	}
}

export function getPlanDetails(
	mobilePlans: any,
	targetedPromo?: any,
	retailerName?: string,
	simKitValue?:number,
	promoStackingBehavior?:string,
	isTacticaloffer?:boolean
): any {
	const hasTargetedPromo = targetedPromo ? true : false;
	const globalPromos = mobilePlans.discounts.filter(
		(discount) => discount?.discountType?.toLowerCase() === "global"
	);
	console.log("Tactical Promo",isTacticaloffer);
	const mobilePlan = {
		name: mobilePlans.name,
		price: mobilePlans.quoteItemPrice[0].price.value,
		weight: mobilePlans.weight,
		type: "",
		isActive: mobilePlans.selected === "true",
		selected: mobilePlans.selected,
		quoteItemPrice: mobilePlans.quoteItemPrice,
		// iconImage: `nbn${plan}.svg`,
		// iconImageDisabled: `nbn${plan}-disabled.svg`,
		digitalUIMarketing: mobilePlans.digitalUIMarketing,
		parentElementGuid: mobilePlans.parentElementGuid,
		elementGuid: mobilePlans.elementGuid,
		recurringRPCID: mobilePlans.quoteItemPrice[0].price.attributes.filter(
			(attribute) => attribute.name?.toLowerCase() === "recurring_rpc_id"
		)[0]?.value,
		discount: undefined,
		mobileTacticalOffers: undefined,
		persistentPromoDiscount: undefined,
		discounts: mobilePlans.discounts,
		thirdPartyDiscounts: undefined,
		title: getTitleText(mobilePlans),
		titleGB: getTitleTextGB(mobilePlans),
		promoTitle: getDiscountText(mobilePlans),
		hasMassMarketPromo : globalPromos && globalPromos.length > 0 && !hasTargetedPromo ? true : false
	};
	mobilePlan.discount = getMobileDiscount(
		mobilePlans,
		targetedPromo,
		hasTargetedPromo,
		mobilePlan.recurringRPCID,
		retailerName,
		simKitValue,
		promoStackingBehavior
	);
	if(isTacticaloffer){
		const tacticalOffers = getMobileDiscount(
			mobilePlans,
			targetedPromo,
			hasTargetedPromo,
			mobilePlan.recurringRPCID,
			retailerName,
			simKitValue,
			promoStackingBehavior,
			isTacticaloffer
		);	
		console.log("tactical Offers => ",tacticalOffers)
		if(tacticalOffers?.length >0){
			tacticalOffers?.sort((a,b)=>{
				if(a.isData === true) return -1;
				if(b.isData === true) return 1;
				return 0;
			});	
			mobilePlan.mobileTacticalOffers = tacticalOffers;
		}
	}
	mobilePlan.persistentPromoDiscount = mobilePlans?.discounts?.find(
		(discount) => discount?.discountType?.toLowerCase() === "retail_distribution" && discount?.weight === "99"
	);
	return mobilePlan;
}

export function getTitleText(plan: any): string {
	return plan?.quoteItemPrice[0]?.price?.value;
}

export function getTitleTextGB(plan: any): string {
	return plan.quoteItemPrice[0].price.attributes.find(
		(attribute) => attribute.name === "Data_Allowance"
	)?.value;
}

export function getMydodoPlanPrice(mobilePlan: any): number {
	if (hasPromoDiscount(mobilePlan)) {
		return (
			parseFloat(mobilePlan.price) + parseFloat(mobilePlan?.discount?.value)
		);
	} else {
		return parseFloat(mobilePlan?.quoteItemPrice[0]?.price?.value);
	}
}

export function getMydodoMobileDiscountDetails(
	mobilePlan: any,
	remainingValue: string,
	targetedPromo?: any,
): any {
	const price = getMydodoPlanPrice(mobilePlan) ?? 0;
	const simCredit = parseFloat(remainingValue?.replace("$", ""));
	const dueToday  = (price - simCredit) > 0 ? (price - simCredit) : 0;
	const creditRemaining = simCredit - price;

	const mobileObj = {
		title: `$${getTitleText(mobilePlan)}-${getTitleTextGB(mobilePlan)}`,
		creditRemaining: creditRemaining > 0 ? creditRemaining : 0, 
		simCredit: simCredit,
		dueToday: dueToday,
		monthlyCost: getMydodoPlanPrice(mobilePlan),
		discount: hasPromoDiscount(mobilePlan)
			? mobilePlan?.discount?.value
			: undefined,
		upToPeriod: hasPromoDiscount(mobilePlan)
			? mobilePlan?.discount?.upToPeriod
			: "",
		bonusDataTitle: setCartDataPromoTitle(mobilePlan),
		doubleDataTitle:  mobilePlan?.discount?.isData ? setDoubleDataPromo(mobilePlan) : "",
		doubleDataDescription: mobilePlan?.discount?.isData ? `+${getTitleTextGB(mobilePlan)}`  : "",
		bonusDescription: mobilePlan?.discount?.isData
			? `Then ${getTitleTextGB(mobilePlan)}`
			: "",
		monthlyText: getMonthlyText(mobilePlan),
		targetedPromo: targetedPromo || null,
	};
	return mobileObj;
}


export function getMobileTacticalDiscountDetails(
	mobilePlan: any,
	remainingValue: string,
	targetedPromo?: any,
	tacticalPromoOffers?:any,
): any {	
	let tacticalOffers:any = [];
	const isTacticaloffer = (tacticalPromoOffers?.length > 0 && !targetedPromo);
	if(tacticalPromoOffers?.length > 0){
	tacticalOffers = setCartTacticalOffersDisounts(tacticalPromoOffers);
	if(tacticalOffers?.length >0){
		tacticalOffers?.sort((a,b)=>{
					if(a.isData === false) return -1;
					if(b.isData === false) return 1;
					return 0;
				});	
		}
	}

	const price = setPlanPriceByTactical(mobilePlan, tacticalOffers) ?? 0;
	const simCredit = parseFloat(remainingValue?.replace("$", ""));
	const dueToday  = (price - simCredit) > 0 ? (price - simCredit) : 0;
	const creditRemaining = simCredit - price;

	console.log("mobile plan")
	console.log(mobilePlan)

	const mobileObj = {
		title: `$${getTitleText(mobilePlan)}-${getTitleTextGB(mobilePlan)}`,
		creditRemaining: creditRemaining > 0 ? creditRemaining : 0, 
		simCredit: simCredit,
		discount: getPromoDiscountAmount(tacticalOffers),
		dueToday: dueToday,
		monthlyCost: mobilePlan.price,
		monthlyText: getMonthlyText(mobilePlan),
		targetedPromo: targetedPromo || null,
		tacticalOffers: tacticalOffers || []
	};
	console.log("getPromoDiscountAmount(tacticalOffers) => ", getPromoDiscountAmount(tacticalOffers));
	console.log("Called Get Discount Details mobile ")
	return mobileObj;
}

export function setPlanPriceByTactical(mobilePlan:any, tacticalOffers:any): number {
	const discount = getPromoDiscountAmount(tacticalOffers);	
	return parseFloat(mobilePlan?.price) + discount;
}

